import { render, staticRenderFns } from "./qs-statisticsNew.vue?vue&type=template&id=4d08794a&scoped=true&"
import script from "./qs-statisticsNew.vue?vue&type=script&lang=ts&"
export * from "./qs-statisticsNew.vue?vue&type=script&lang=ts&"
import style0 from "./qs-statisticsNew.vue?vue&type=style&index=0&id=4d08794a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d08794a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/business/yq-monitor-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d08794a')) {
      api.createRecord('4d08794a', component.options)
    } else {
      api.reload('4d08794a', component.options)
    }
    module.hot.accept("./qs-statisticsNew.vue?vue&type=template&id=4d08794a&scoped=true&", function () {
      api.rerender('4d08794a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataStatistics/qs-statisticsNew.vue"
export default component.exports